var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-bubble-color",style:({ background: [_vm.generateColor] })},[_vm._t("bubble-content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }